"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModuleList = exports.getModuleCustomScope = exports.scopeList = exports.setModuleSelection = exports.ModulePermissions = exports.ScopeType = exports.ScopeSelectionType = exports.Module = exports.ModuleType = exports.getModuleSelection = exports.getModuleList = exports.menuacl = exports.scope = exports.acl = void 0;
const scope = __importStar(require("./scope"));
exports.scope = scope;
const acl = __importStar(require("./acl"));
exports.acl = acl;
const menuacl = __importStar(require("./menu"));
exports.menuacl = menuacl;
const role_1 = require("./role");
Object.defineProperty(exports, "getModuleList", {
  enumerable: true,
  get: function () {
    return role_1.getModuleList;
  }
});
Object.defineProperty(exports, "getModuleSelection", {
  enumerable: true,
  get: function () {
    return role_1.getModuleSelection;
  }
});
Object.defineProperty(exports, "ModuleType", {
  enumerable: true,
  get: function () {
    return role_1.ModuleType;
  }
});
Object.defineProperty(exports, "Module", {
  enumerable: true,
  get: function () {
    return role_1.Module;
  }
});
Object.defineProperty(exports, "ScopeSelectionType", {
  enumerable: true,
  get: function () {
    return role_1.ScopeSelectionType;
  }
});
Object.defineProperty(exports, "ScopeType", {
  enumerable: true,
  get: function () {
    return role_1.ScopeType;
  }
});
Object.defineProperty(exports, "ModulePermissions", {
  enumerable: true,
  get: function () {
    return role_1.ModulePermissions;
  }
});
Object.defineProperty(exports, "setModuleSelection", {
  enumerable: true,
  get: function () {
    return role_1.setModuleSelection;
  }
});
Object.defineProperty(exports, "scopeList", {
  enumerable: true,
  get: function () {
    return role_1.scopeList;
  }
});
Object.defineProperty(exports, "getModuleCustomScope", {
  enumerable: true,
  get: function () {
    return role_1.getModuleCustomScope;
  }
});
Object.defineProperty(exports, "ModuleList", {
  enumerable: true,
  get: function () {
    return role_1.ModuleList;
  }
});
// export type MenuScopeList = {
//     [key: string]: {
//         Main: string[],
//         SubMenu: {[key: string]: string[]}
//     }
// };
// export type ScopeList = {
//     [key: string]: string[]
// };
